export const NO_IMAGE = 'https://uzone360live.s3.amazonaws.com/noimage.png';

const AVATAR_COLORS = ['#1EA08D', '#D86A34', '#D9A334', '#7DA341', '#C9604F', '#4A90D9', '#8E5BAA'];

export const getAvatarColor = (name) => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
};

export const getInitials = (first = '', last = '') =>
  (((first || '')[0] || '') + ((last || '')[0] || '')).toUpperCase() || '?';

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '';
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return `${Math.max(diffMin, 1)}m`;
  if (diffMin < 1440) return `${Math.floor(diffMin / 60)}h`;
  return `${Math.floor(diffMin / 1440)}d`;
};

// user_data in redux is stored as a JSON string, and its shape has varied
// between {user: {...}} (auth responses) and a flat user record depending on
// call site — check both so callers get a working id/user regardless.
export const getCurrentUser = (userDataRaw) => {
  if (!userDataRaw) return null;
  let parsed = userDataRaw;
  if (typeof userDataRaw === 'string') {
    try {
      parsed = JSON.parse(userDataRaw);
    } catch (e) {
      return null;
    }
  }
  return parsed?.user || parsed || null;
};

// Addresses saved from a map picker often come back prefixed with a Google
// Plus Code (e.g. "7WM9+XPM, Tamluk, ...") - that's a geocode, not part of
// the human-readable address, so strip it before displaying.
export const formatAddress = (raw) => (raw || '').replace(/^[23456789CFGHJMPQRVWX]{2,8}\+[23456789CFGHJMPQRVWX]{2,4}\s*,?\s*/i, '').trim();

export const apiSucceeded = (res) => res?.data?.response?.status === 200;

export const apiErrorMessage = (res, fallback) =>
  res?.response?.data?.data?.message ||
  res?.response?.data?.message ||
  res?.response?.data?.errors?.[0]?.message ||
  fallback;
